import React, { useEffect } from "react";
import { Select } from "@paylixecommerce/shared/components";
import { useDispatch, useSelector } from "react-redux";
import { getProductList } from "../../entrypoints/dashboard/screens/products/product/actions";
import { getGroupList } from "../../entrypoints/dashboard/screens/products/group/actions";

const ALL = { label: "All Products", value: "*"};

const ProductMultiSelect = ({ label, enableUnlisted, isAllProductsEnabled, isGroup, name, setFieldValue, values, touched, errors }) => {

	let isError = errors[name] && touched[name];
	let dispatch = useDispatch();
	let products = useSelector(({ products: { product_list } }) => product_list
		.filter(({type}) => type !== "INFO_CARD")
		.filter(({ unlisted }) => enableUnlisted ? true : !Number(unlisted))
	);
	const groups = useSelector(({ groups: { group_list } }) => group_list
		.filter(({ unlisted }) => !Number(unlisted))
	);

	let products_list = products.map(({ uniqid: value, title: label }) => ({ label, value }));
	let groups_list = groups.map(({ uniqid: value, title: label }) => ({ label, value }));

	useEffect(() => {
		if(isGroup) {
			dispatch(getGroupList());
		} else {
			dispatch(getProductList());
		}
	}, []);

	let isAll = isAllProductsEnabled ? values[name] && values[name].length && values[name].find(({ value }) => value === "*") : false;

	return <div className="mb-4">
		<label className="paylixecommerce-label" htmlFor={name}>{label ? label : isGroup ? "Groups" : "Products"}</label>

		<Select
			options={isAllProductsEnabled ? (isAll ? [ALL] : isGroup ? [ALL, ...groups_list] : [ALL, ...products_list]) : isGroup ? [...groups_list] : [...products_list]}
			className={isError && "is-invalid-select"}
			name={name}
			isMulti={true}
			// menuIsOpen={true}
			noOptionsMessage={() => isAllProductsEnabled ? (isAll ? null : isGroup ? "No groups found" : "No products found") : null}
			placeholder={isGroup ? "Select Groups" : "Select Products"}
			isSearchable={true}
			value={values[name]}
			onChange={options => {
				if(options && options.length && options.find(({ value }) => value === "*")) {
					setFieldValue(name, [ALL])
				} else {
					setFieldValue(name, options)
				}
			}}
		/>


		{isError && <div className="invalid-feedback">{errors[name]}</div>}
	</div>
}

export default ProductMultiSelect;
